// LIBRARIES

import styled from "styled-components";

//MISC

import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  MARGIN,
  SIZE,
  DEVICE_TYPE,
} from "constants/variables";

export const PositionContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 3%;
  padding: 0 ${SIZE.max100};
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    padding: 0 ${SIZE.max60};
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    padding: 0;
    bottom: 0;
  }
  z-index: 5;
`;

export const Container = styled.div<{
  isOpen: boolean;
}>`
  width: 100%;
  height: 88px;
  padding: ${MARGIN.max20} ${MARGIN.fix32};
  background-color: ${COLORS.RaisinBlack};
  border-radius: ${BORDER_RADIUS.radius26};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    flex-direction: column;
    height: auto;
    gap: ${SIZE.max24};
  }
`;

export const LineContainer = styled.div`
  height: 2px;
  width: 40px;
  background-color: ${COLORS.Background};
`;

export const ModalContent = styled.div`
  gap: ${SIZE.max24};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 55%;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 65%;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 80%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${SIZE.max12};
`;
export const Title = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    width: 55%;
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 65%;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 80%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
  }
`;

export const SearchContainer = styled.div`
  background-color: ${COLORS.Gunmetal};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 7px 8px;
  border-radius: ${BORDER_RADIUS.radius32};
  gap: 8px;
  height: 48px;
  svg {
    height: 20px;
    width: 20px;
    margin-left: 16px;
    @media (max-width: ${DEVICE_TYPE.mobile}) {
      height: 18px;
      width: 18px;
      margin-left: 8px;
    }
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    width: 100%;
  }
`;

export const SearchInput = styled.input`
  border: none;
  background-color: transparent;
  text-decoration: none;
  color: ${COLORS.Background};
  font-size: ${FONT_SIZE.fix16};
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.regular};
  width: ${SIZE.max240};
  text-overflow: ellipsis;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis !important;
  }
  &:focus {
    border: none;
    outline: none;
  }
`;

export const RedButtonWrapper = styled.div`
  width: ${SIZE.max180};
  height: 48px;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    margin-top: ${SIZE.max100};
  }
`;
